// extracted by mini-css-extract-plugin
export default {"titleCategory":"projectdetail_titleCategory__amyMc","imgProject":"projectdetail_imgProject__kV5gL"};